<template>
  <v-container class="pb-0 px-0">
    <v-data-iterator
      :loading="documents.loading"
      :items="documents.summary"
      hide-default-footer
      fixed-header
      class="comment-table document-table"
      style="margin-top: -15px; z-index: 0; position: relative; margin-bottom: 0;"
    >
      <template v-slot:default="props">

        <v-row justify="center" class="ma-0">
          <v-col
            v-for="item in props.items"
            :key="item.type"
            cols="12"
            sm="6"
            :md="parseInt(12 / props.items.length) >= 2 ? parseInt(12 / props.items.length) : 4"
            :lg="parseInt(12 / props.items.length) >= 2 ? parseInt(12 / props.items.length) : 3"
            style="min-width: 148px;"
            class="pa-2"
          >
            <v-card
              :color="verificationState(item)"
            >
              <v-card-title class="subheading font-weight-bold pa-2">
                {{ item.type }}

                <v-spacer />

                <v-checkbox
                  style="width: 24px"
                  class="ma-0"
                  v-model="kyc.details[item.type]"
                  hide-details
                  color="grey darken-4"
                  @change="saveDetails(item.type, ['details', item.type])"
                  :readonly="!$store.state.auth.checkAccess({key: 'kyc_verification', value: true})"
                ></v-checkbox>
              </v-card-title>

              <v-divider></v-divider>

              <v-list dense class="rounded-0 documents-type-list">

                <v-list-item>
                  <v-list-item-content>New:</v-list-item-content>
                  <v-list-item-action class="align-end">{{ item.new }}</v-list-item-action>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>Accepted:</v-list-item-content>
                  <v-list-item-action class="align-end">{{ item.accept }}</v-list-item-action>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>Declined:</v-list-item-content>
                  <v-list-item-action class="align-end">{{ item.decline }}</v-list-item-action>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-btn
                      small
                      outlined
                      :text="documents.type !== item.type"
                      @click="showDetails(item)"
                    >
                      {{ documents.type == item.type ? 'Close' : 'Preview' }}
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>

              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </template>

    </v-data-iterator>

    <v-expand-transition>
      <v-data-table
        v-if="!!documents.type"
        :headers="headers"
        :loading="documents.loading"
        :items="documents.items[documents.type] || []"
        :sort-by="['created']"
        :sort-desc="[true, true]"
        height="350"
        fixed-header
        class="comment-table"
        style="z-index: 0; position: relative; margin-bottom: 0px;"
      >
        <template v-slot:header.action="{ item }">
          <v-icon @click="documents.type = null">mdi-close</v-icon>
        </template>

        <template v-slot:item.created="{ item }">
          <div class="d-flex">
            {{ item.updated || item.created }}
            <v-tooltip
              right
              close-delay="1500"
              v-if="item.account_id !== activeAccount.account_id"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="light-green">
                    mdi-account-alert
                  </v-icon>
                </v-btn>
              </template>
              <a class="white--text" :href="`/user-management/${item.data.prefix}${item.data.login}`" target="_blank">{{ `${item.data.prefix}${item.data.login}` }}</a>
            </v-tooltip>
          </div>
        </template>

        <template v-slot:item.data.comment="{ item }">
          <span class="ql-editor" style="padding: 0; margin: 0" v-html="$sanitize(item.data.comment)"></span>
        </template>

        <template v-slot:item.data.internal_comment="{ item }">
          <span class="ql-editor" style="padding: 0; margin: 0" v-html="$sanitize(item.data.internal_comment)"></span>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            small
            light
            class="rounded-6 height-25  font-size-13"
            :color="getColor(item.status)">{{ item.status }}
          </v-chip>
        </template>
        <template v-slot:item.action="{ item }">
          <span style="white-space: nowrap">
            <v-icon
              color="green"
              @click="documentVerification(item,true)"
            >
            mdi-check-circle
          </v-icon>
          <v-icon
            color="red"
            @click="documentVerification(item,false)"
          >
            mdi-close-circle
          </v-icon>
          <v-icon
            class="ml-2"
            @click="viewDocument(item)"
          >
            mdi-cog
          </v-icon>
            </span>
        </template>
        <template v-slot:no-data>
          <v-btn @click="$store.dispatch('account/loadKYC', { account: activeAccount.account })" text fab class="my-4">
            <v-icon x-large>refresh</v-icon>
          </v-btn>
        </template>

        <template v-slot:footer="{ pageStart , pageStop , itemsLength }">
          <v-btn style="margin-bottom: -75px" color="primary" @click="addItem()" dark icon>
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <template v-slot:footer.page-text="{ pageStart , pageStop , itemsLength }">
          {{ pageStart }} - {{ pageStop }} of {{ itemsLength }}
          <v-btn @click="$store.dispatch('account/loadKYC', { account: activeAccount.account })" icon style="margin-right: -35px;">
            <v-icon>refresh</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-expand-transition>

    <v-dialog
      v-model="newDialog"
      scrollable
      max-width="900px"
      v-if="newDialog"
    >
      <v-card v-if="newItem">
        <v-card-title>
          {{ newItem.file ? 'Upload' : 'Request' }} document
          <v-spacer />
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-simple-table class="mt-1">
            <template v-slot:default>
              <tbody>
                <tr>
                  <td><b>Comment:</b></td>
                  <td>
                    <withdraw-comments v-model="newItem.comment" :commentsPreset="$options.commentsPreset" :save-icon="false" />
                    <!--                    <v-select-->
                    <!--                      v-model="newItem.comment"-->
                    <!--                      :items="$options.commentsPreset"-->
                    <!--                      hide-details-->
                    <!--                      class="my-0 pt-0"-->
                    <!--                    />-->
                  </td>
                </tr>
                <tr>
                  <td><b>Internal Comment:</b></td>
                  <td>
                    <withdraw-comments v-model="newItem.internal_comment" :commentsPreset="$options.internalPreset" :save-icon="false" />

                    <!--                    <v-select-->
                    <!--                      v-model="newItem.internal_comment"-->
                    <!--                      :items="$options.internalPreset"-->
                    <!--                      hide-details-->
                    <!--                      class="my-0 pt-0"-->
                    <!--                    />-->
                  </td>
                </tr>
                <tr>
                  <td width="200px">
                    <v-select
                      v-if="types.length > 0"
                      label="Type"
                      v-model="newItem.type"
                      :items="types"
                      :rules="[v => !!v || 'Type is required']"
                      required
                    />
                    <v-text-field
                      v-if="types.length === 0"
                      label="Type"
                      v-model="newItem.type"
                      :rules="[v => !!v || 'Type is required']"
                      required
                    />
                  </td>
                  <td>
                    <v-file-input
                      :disabled="uploading"
                      :loading="uploading"
                      v-model="newItem.file"
                      class="mb-2"
                      hide-details
                      accept="image/png, image/jpeg, image/bmp, image/heif, image/heic, image/heif-sequence, image/heic-sequence, application/pdf"
                      placeholder="Document: image/png, image/jpeg, application/pdf, image/heif, image/heic"
                      prepend-icon="mdi-camera"
                      label="Document"
                    />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-divider />
        <v-card-actions class="px-6">
          <v-btn
            color="warning"
            @click="newDialog = false; newItem = null"
          >
            Close
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn
            :disabled="uploading"
            :loading="uploading"
            color="success"
            @click="upload(newItem)"
          >
            {{ newItem.file ? 'Upload' : 'Request' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <update-form
      v-model="dialog"
      :item="prepareItem(item)"
      @save="save"
      :openImage="openImage"
      :loading="loading"
      :commentsPreset="$options.commentsPreset"
      :internalPreset="$options.internalPreset"
    />

  </v-container>
</template>

<style>
  .comment-table td {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .comment-table td > span > p {
    padding: 0;
    margin: 0;
  }

  .documents-type-list .v-list-item {
    min-height: 26px;
  }

  .documents-type-list .align-end {
    justify-content: flex-end;
  }

  .documents-type-list .v-list-item .v-list-item__content,
  .documents-type-list .v-list-item .v-list-item__action {
    padding: 0px;
    margin: 0px;
  }

</style>

<script>
  import Vue from 'vue'

  import WithdrawComments from '@/components/helper/WithdrawComments.vue'
  import UpdateForm from '@/components/documents/UpdateForm'
  import { get, cloneDeep, set } from 'lodash'
  import { mapGetters } from 'vuex'
  import { API } from '@/utils/api'
  import { commentsPreset, internalPreset } from '@/utils/mock'

  export default {
    commentsPreset,
    internalPreset,
    components: { UpdateForm, WithdrawComments },

    data: () => ({
      dialog: false,
      newDialog: false,
      loading: false,
      uploading: false,
      item: false,
      newItem: false,
      types: [],
      headers: [
        { text: 'Date', value: 'created' },
        // { text: 'Type', value: 'type', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Comment', align: 'left', sortable: false, value: 'data.comment' },
        { text: 'Int Comment', align: 'left', sortable: false, value: 'data.internal_comment' },
        { text: 'Operator', align: 'left', sortable: false, value: 'data.operator_name' },
        { text: '', value: 'action', sortable: false, align: 'right' },
      ],

      chipColor: {
        accept: 'green lighten-3',
        decline: 'red lighten-3',
      }
    }),

    computed: {
      ...mapGetters({ activeAccount: 'account/active', documents: 'account/documents', kyc: 'account/kyc' }),
    },

    watch: {},

    mounted () {
    },

    created () {
    },

    methods: {
      get, cloneDeep,

      viewDocument: function (item) {
        this.item = item
        this.dialog = true
      },
      prepareItem: function (item) {

        return Vue.observable(cloneDeep(item))
      },

      verificationState: function (item) {

        if (item.new == 0 && item.on_review == 0 && item.accept == 0 && item.decline > 0) {
          return 'red lighten-3'
        }
        if (((item.new >= 0 && item.decline > 0) || (item.new > 0 && item.decline >= 0)) && item.on_review >= 0 && item.accept > 0) {
          return 'orange lighten-3'
        }
        if (item.new == 0 && item.on_review == 0 && item.accept > 0 && item.decline == 0) {
          return 'green lighten-3'
        }

        return
      },

      showDetails: function (item) {
        if (this.documents.type == item.type) {
          this.documents.type = null
        } else {
          this.documents.type = item.type
        }
      },

      getColor: function (status) {
        return this.chipColor[status]
      },

      addItem: function (item) {
        this.newDialog = true
        this.newItem = { type: '' }
        this.loadTypes()
      },

      loadTypes: function () {
        this.loading = true

        API.call('/$v/documents/types.json', {
          account_id: this.activeAccount.account.account_id,
        }, this.activeAccount.account)
          .then(resp => this.types = resp.data)
          .then(resp => (this.newItem.type = this.types[0]))
          .finally(r => {
            this.loading = false
          })
      },

      async saveDetails (field, path) {

        if (!this.$store.state.auth.checkAccess({ key: 'kyc_verification', value: true }) ||
          !await this.$root.$confirm('Confirm', `Update ${field}: ${get(this.kyc, path) ? 'Yes' : 'No'}`)) {
          set(this.kyc, path, !get(this.kyc, path))

          return
        }

        let params = { login: this.activeAccount.account.login, account_id: this.activeAccount.account_id }

        set(params, path, get(this.kyc, path))

        this.loading = true
        API.call('/$v/account/kyc/update.json', params, this.activeAccount.account).then(resp => {
        }).finally(r => {
          this.loading = false
        })
      },

      save: function (item) {
        this.loading = true

        API.call('/$v/documents/update.json', {
          document_id: item.document_id,
          account_id: item.account_id,
          status: item.status,
          comment: item.data.comment,
          internal_comment: item.data.internal_comment,
          type: item.type
        }, this.activeAccount.account).then(resp => resp.data).finally(r => {
          this.loading = false

          this.$store.dispatch('account/loadKYC', { account: this.activeAccount.account })

          this.dialog = false
        })
      },

      upload: function (item) {

        if (!this.newItem.type) return

        this.uploading = true
        const reader = new FileReader()

        reader.onload = (e) => {
          let file = e.target.result

          this.uploadRequest(item, file)
        }

        if (item.file) {
          item.filename = item.file.name

          reader.readAsDataURL(item.file)
        } else {
          this.uploadRequest(item,)
        }
      },

      uploadRequest: function (item, file) {
        return API.call('/$v/documents/upload.json', {
          document_id: item.document_id,
          account_id: this.activeAccount.account.account_id,
          type: item.type,
          comment: item.comment,
          status: 'accept',
          internal_comment: item.internal_comment,
          filename: item.filename,
          file
        }, this.activeAccount.account).then(resp => resp.data).finally(r => {

          this.$store.dispatch('account/loadKYC', { account: this.activeAccount.account })
          this.newDialog = false
          this.uploading = false
        })
      },

      documentVerification: async function (item, status) {
        let message = status ? 'Accept documents' : 'Decline documents'
        if (!await this.$root.$confirm('Confirm', message)) return

        status = status ? 'accept' : 'decline'

        item.status = status

        return this.save(item)
      },

      async openImage (item, open = true) {
        this.loading = true
        return API.call('/$v/documents/image.json', {
          document_id: item.document_id,
          account_id: this.activeAccount.account.account_id,
        }, this.activeAccount.account).then(resp => resp.data).then(r => {

          if (!open) {
            return r.img
          }

          if (r.img.match(/^data/)) {

            if (window.URL) {

              function base64ToArrayBuffer (_base64Str) {
                let binaryString = window.atob(_base64Str)
                let binaryLen = binaryString.length
                let bytes = new Uint8Array(binaryLen)
                for (let i = 0; i < binaryLen; i++) {
                  let ascii = binaryString.charCodeAt(i)
                  bytes[i] = ascii
                }
                return bytes
              }

              let data = r.img.match(/data:(.*)?;base64,(.*)?/)

              let byte = base64ToArrayBuffer(data[2])

              let blob = new Blob([ byte ], { type: data[1] })

              window.open(window.URL.createObjectURL(blob), '_blank')

            } else {

              let w = window.open('')
              if (r.img.match(/^data:application\/pdf/)) {
                w.document.write('<html><body style="margin:0!important"><embed width="100%" height="100%" src="' + r.img + '" /></body></html>')
              } else {
                w.document.write('<html><body style="margin:0!important"><embed style="max-width: 100%; max-height: 100%;" src="' + r.img + '" /></body></html>')
              }
              w.stop()
            }

          } else {
            window.open(r.img, '_blank')
          }

        }).finally((r) => {
          this.loading = false
          return r
        })
      },
    },
  }
</script>
